<template>
  <div class="container">
    <!-- <div class="yindaoru" v-if="xue" @click="xues">
      <div class="qian">选择你要学习的课程</div>
      <video
        src="../../assets/xue.mp4"
        class="videp"
        :autoplay="autoplay"
        loop="true"
        id="xuess"
        muted="“muted”"
      ></video>
    </div> -->

    <dingbu></dingbu>
    <div class="home_content">
      <div
        class="bg_color"
        :style="{
          background:
            'url(' +
            require('../../assets/img/' + bei_ing) +
            ') no-repeat center center',
          'background-size': '100% 100%',
        }"
      >
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">学习系统</span>
            </div>
          </div>
        </div>
        <div class="box-contenthh">
          <div class="box-top-list" v-if="is_true">
            <div class="top-list-one">
              <div class="sort_name">{{ title.title_one }}：</div>
              <div class="one-li">
                <div
                  v-for="(item, index) in list"
                  :data-id="item.id"
                  :data-index="index"
                  :key="index"
                  @click="one"
                  :class="orderindex == index ? 'actives' : ''"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="top-list-one">
              <div class="sort_name">{{ title.title_two }}：</div>
              <div class="one-li">
                <div
                  v-for="(item, index) in listtwo"
                  :key="index"
                  :data-id="item.id"
                  :data-index="index"
                  @click="two"
                  :class="orderindet == item.id ? 'actives' : ''"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="box-logh">
            <div
              class="box-tosgh"
              v-for="(item, index) in addki"
              :key="index"
              :plain="true"
              @click="profile(item.id)"
            >
              <div class="tos-img">
                <img class="shiping-lk" :src="item.image" alt />
              </div>
              <div class="tos-title">{{ item.examname }}</div>
              <div class="tos-timep">
                <div class="suoxud">所需课时：</div>
                <div class="keshi">{{ item.class_hour }}课时</div>
              </div>
              <div class="tos-timem">
                <div class="suoxud">已完成课时：</div>
                <div class="keshi">{{ item.finish_hour }}课时</div>
              </div>
              <div class="tos-timem">
                <div class="suoxud">截止日期：</div>
                <div class="keshi">{{ item.expirationtime }}</div>
              </div>
            </div>
          </div>

          <div class="fenye">
            <el-pagination
              background
              layout="prev, pager, next,jumper"
              :total="total"
              :page-size="pageNum"
              @prev-click="prev"
              @next-click="next"
              @current-change="current"
            ></el-pagination>
          </div>
        </div>
        <dibu></dibu>
      </div>
    </div>
    <daohan></daohan>
  </div>
</template>

<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
export default {
  components: {
    daohan,
    dibu,
    dingbu,
  },
  data() {
    return {
      addki: [],
      page: 1,
      pageNum: 12,
      total: 1,
      title: [],
      list: [],
      orderindex: 0,
      orderindet: "",
      orderindek: "",
      id: 1,
      listtwo: [],
      listthree: [],
      xue: false,
      autoplay: true,
      bei_ing: this.Public.bei_ing,
      is_true: true,
    };
  },
  mounted() {
    // window.addEventListener("beforeunload", (e) => {
    //   this.autoplay = true
    // });
    // if (localStorage.getItem("token-qzb")) {
    //   if (sessionStorage.getItem("xue") == 1) {
    //     this.xue = true;
    //     document.documentElement.scrollTop = 150;
    //     document.body.style.overflow = "hidden";
    //     document.addEventListener("touchmove", { passive: false }); // 禁止页面滑动
    //   }
    // }
  },
  created() {
    this.$forceUpdate();
    if (this.$route.query.info && JSON.parse(this.$route.query.info)) {
      let query = JSON.parse(this.$route.query.info);
      console.log(query);
      if (query) {
        this.id = query.id;
        // this.is_true = query.is_true;
      }
    }
    let token = localStorage.getItem("token-qzb");
    console.log(token);
    this.getstudy();
    this.getlists();
    this.gettitle();
    this.getkey();
  },
  methods: {
    // xues() {
    //   sessionStorage.setItem("xue", 2);
    //   this.xue = false;
    //   document.body.style.overflow = ""; // 出现滚动条
    //   document.removeEventListener("touchmove", { passive: false });
    // },
    //标签切换
    one(e) {
      this.orderindex = e.target.dataset.index;
      this.id = e.target.dataset.id;
      let that = this;
      var url = "lists/get_list";
      let param = {
        id: that.id,
      };
      this.post(url, param)
        .then((res) => {
          that.listtwo = res.data;
          that.listthree = "";
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
      this.getstudy();
      this.orderindet = "";
    },
    two(e) {
      this.orderindet = e.target.dataset.id;
      this.id = e.target.dataset.id;
      let that = this;
      var url = "lists/get_list";
      let param = {
        id: that.id,
      };
      this.post(url, param)
        .then((res) => {
          that.listthree = res.data;
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
      this.getstudy();
    },
    therr(e) {
      this.orderindek = e.target.dataset.id;
      this.id = e.target.dataset.id;
      // this.getlists();
      this.getstudy();
    },
    //分页
    //上一页
    prev() {
      console.log("eee");
      this.page = this.page - 1;
      this.getstudy();
    },
    //下一页
    next() {
      console.log("eee");
      this.page = this.page + 1;
      this.getstudy();
    },
    //当前页
    current(e) {
      console.log(e);
      this.page = e;
      this.getstudy();
    },
    //点击跳转到我的资料
    profile(id) {
      //判断用户是否有权限
      let token = localStorage.getItem("token-qzb");
      if (token) {
        let that = this,
          url = "lists/study_detail",
          param = {
            id: id,
            pageNum: that.pageNum,
            page: that.page,
          };
        that
          .post(url, param)
          .then((res) => {
            localStorage.setItem("ordertodo", 0);
            if (res.code == 1) {
              sessionStorage.setItem("idto", id);
              // if (sessionStorage.getItem("ziliao")) {
              // } else {
              //   sessionStorage.setItem("ziliao", 1);
              // }
              this.$router.push({
                path: "/profile",
                query: { id: id },
              });
            } else if (res.code == 0) {
              // this.$message(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        localStorage.setItem("id", id);
        this.$message("请先登录");
        this.$router.push("/login");
      }
    },
    //分类标题
    gettitle() {
      let that = this;
      var url = "lists/type_title";
      let param = {
        page: this.page,
        pageNum: this.pageNum,
      };
      this.post(url, param)
        .then((res) => {
          that.title = res.data;
          console.log(that.title);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //根据id获取分类列表
    getkey() {
      let that = this,
        url = "lists/get_list",
        param = {
          id: this.id || 1,
        };
      this.post(url, param)
        .then((res) => {
          that.listtwo = res.data;
          that.listthree = "";
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //分类标题
    getlists() {
      let that = this;
      var url = "lists/type_list";
      let param = {
        id: that.id,
      };
      this.post(url, param)
        .then((res) => {
          that.list = res.data.one;
          console.log(res, "  //分类标题");

          if (this.id) {
            that.list.forEach((item, index) => {
              if (that.id == item.id) {
                this.orderindex = index;
                this.id = item.id;
                let that = this;
                var url = "lists/get_list";
                let param = {
                  id: that.id,
                };
                this.post(url, param)
                  .then((res) => {
                    that.listtwo = res.data;
                    that.listthree = "";
                    console.log(res);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
                this.getstudy();
                this.orderindet = "";
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //学习系统接口
    getstudy() {
      let that = this;
      var url = "lists/study";
      let param = {
        page: that.page,
        pageNum: that.pageNum,
        type_id: that.id,
      };
      this.post(url, param)
        .then((res) => {
          this.addki = res.data.info;
          this.total = res.data.total_num;
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #2d52b1 !important;
  color: #fff;
  border-radius: 50%;
}
.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #ffffff;
  color: #06121e;
  min-width: 30px;
  border-radius: 2px;
}
</style>
<style scoped>
@import "../../css/learn.css";
</style>